import { Alert } from '@mui/material';
import { useSnackbar } from 'notistack';
import { useQueryClient } from 'react-query';
import { transaction, payment } from 'apis';
import { useTranslation } from 'react-i18next';
import { useDialog } from 'context/dialogContext';
import { PaymentMethod } from 'enums';
import { useCardPaymentRqsts } from 'views/application/Payments/Submittion/hooks/data/useCardPaymentRqsts';

export const usePayment = () => {
    const { t } = useTranslation();
    const { enqueueSnackbar } = useSnackbar();
    const { handleAlphaBankRqst, handlePiraeusBankRqst, handleStripeRqst } = useCardPaymentRqsts();

    const submitPayment = async (data) => {
        try {
            const { transactionId, transactionRelId, transactionStatus, operator } = data;
            // const { transactionId, email, fullName, paidAt, paidAmount, captcha, token, comments, paymentMethod } = data;
            // eslint-disable-next-line no-alert
            // TODO Add Custom Confim Dialog Here
            if (data.operator === 'Stripe') await handleStripeRqst(data);
            else
                enqueueSnackbar(t('PaymentSubmittionFail'), {
                    variant: 'error'
                });
        } catch (error) {
            throw new Error(
                'There was an error submitting the payment. Please try again later. If the problem persists, please contact the system administrator.'
            );
        }
    };

    return { submitPayment };
};
